import maplibregl from 'maplibre-gl';

function lngLatsToBounds(coordinates) {

    return coordinates.reduce((bounds, coord) => {

        return bounds.extend(coord);

    }, new maplibregl.LngLatBounds(coordinates[0], coordinates[0]));

}

export default lngLatsToBounds;
